<template>
  <aside class="preview-status" aria-label="Preview environment">
    <span>Preview {{ status.id }} · {{ (status.commit || 'local').slice(0, 8) }} · Sample generated audio</span>
    <strong v-if="status.status !== 'running'"> · {{ status.status }}</strong>
    <button @click="showInbox">Preview inbox</button>
    <dialog ref="inbox">
      <h2>Captured preview email</h2>
      <p>These messages were not sent to recipients.</p>
      <p v-if="error">{{ error }}</p>
      <article v-for="message in messages" :key="message.id">
        <h3>{{ message.fields['Message.Subject.Data'] }}</h3>
        <p>{{ message.fields['Destination.ToAddresses.member.1'] }}</p>
        <pre>{{ message.fields['Message.Body.Text.Data'] }}</pre>
      </article>
      <button @click="$refs.inbox.close()">Close</button>
    </dialog>
  </aside>
</template>

<script>
import { getSessionToken } from '@/lib/auth';
export default {
  data: () => ({ status: {}, messages: [], error: '', timer: null }),
  mounted() {
    this.refresh();
    this.timer = setInterval(this.refresh, 10000);
  },
  beforeUnmount() { clearInterval(this.timer); },
  methods: {
    async refresh() {
      try {
        const response = await fetch('/__preview/status');
        if (response.ok) this.status = await response.json();
        else this.status = { ...this.status, status: 'reconnecting' };
      } catch { this.status = { ...this.status, status: 'reconnecting' }; }
    },
    async showInbox() {
      this.error = '';
      this.messages = [];
      this.$refs.inbox.showModal();
      try {
        const response = await fetch('/__preview/inbox', { headers: { Authorization: `Bearer ${getSessionToken()}` } });
        if (!response.ok) throw new Error('Sign in as the preview admin to view captured email.');
        this.messages = await response.json();
      } catch (error) { this.error = error.message; }
    }
  }
};
</script>

<style scoped>
.preview-status { position: fixed; bottom: 0; left: 0; right: 0; z-index: 10000; padding: 6px 12px; background: #fef3c7; color: #422006; font: 12px/1.5 sans-serif; }
button { margin-left: 16px; text-decoration: underline; }
dialog { width: min(800px, 90vw); max-height: 80vh; padding: 24px; overflow: auto; }
dialog::backdrop { background: #0008; }
article { padding: 16px 0; border-bottom: 1px solid #ddd; }
pre { white-space: pre-wrap; overflow-wrap: anywhere; }
</style>
